import React from 'react';
import { useTranslation } from 'react-i18next';

import { Section, SectionContent, SectionHeader } from 'src/shared/components';

import ServiceList from './components/ServiceList/ServiceList';
import styles from './ServicesSection.module.scss';

const ServicesSection = () => {
	const { t } = useTranslation();

	return (
		<Section name="services" animation="fadeIn" classes={{ section: styles.section }}>
			<SectionHeader title={t('servicesSection.header.title')} description={t('servicesSection.header.description')} />
			<SectionContent>
				<ServiceList />
			</SectionContent>
		</Section>
	);
};

export default ServicesSection;
